import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../../../config';
import { useParams } from "react-router-dom";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const AmonestacionesComponent = () => {
  const [jugadores, setJugadores] = useState([]);
  const [paginaActual, setPaginaActual] = useState(1);
  const jugadoresPorPagina = 5; 
  const { id } = useParams();

  useEffect(() => {
    const fetchJugadores = async () => {
      try {
        const response = await fetch(`${BASE_URL}amonestados/${id}`);
        const data = await response.json();
        setJugadores(data);
      } catch (error) {
        console.error('Error al cargar los datos:', error);
      }
    };

    fetchJugadores();
  }, [id]);

  const tarjetaEstilo = (color) => ({
    display: 'inline-block',
    width: '10px',
    height: '13px',
    backgroundColor: color,
    borderRadius: '3px',
    marginRight: '5px',
  });

  // Paginación
  const totalJugadores = jugadores.length;
  const totalPaginas = Math.ceil(totalJugadores / jugadoresPorPagina);
  const indexOfLastJugador = paginaActual * jugadoresPorPagina;
  const indexOfFirstJugador = indexOfLastJugador - jugadoresPorPagina;
  const jugadoresPaginaActual = jugadores.slice(indexOfFirstJugador, indexOfLastJugador);

  const cambiarPagina = (numeroPagina) => {
    if (numeroPagina >= 1 && numeroPagina <= totalPaginas) {
      setPaginaActual(numeroPagina);
    }
  };

  return (
    <div>
      <h1>Amonestaciones</h1>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead style={{ backgroundColor: '#57B230' }}>
          <tr>
            <th style={{ border: '1px solid #ddd', padding: '8px' }}>Foto</th>
            <th style={{ border: '1px solid #ddd', padding: '8px' }}>Nombre</th>
            <th style={{ border: '1px solid #ddd', padding: '8px' }}>Equipo</th>
            <th style={{ border: '1px solid #ddd', padding: '8px' }}>
              <span style={tarjetaEstilo('yellow')}></span> Tarjetas Amarillas
            </th>
            <th style={{ border: '1px solid #ddd', padding: '8px' }}>
              <span style={tarjetaEstilo('blue')}></span> Tarjetas Azules
            </th>
            <th style={{ border: '1px solid #ddd', padding: '8px' }}>
              <span style={tarjetaEstilo('red')}></span> Tarjetas Rojas
            </th>
          </tr>
        </thead>
        <tbody>
          {jugadoresPaginaActual.map((jugador) => (
            <tr key={jugador.idJugador}>
              <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>
                <img
                  src={jugador.fotografiaPath}
                  alt={`${jugador.nombreJugador} ${jugador.apellidoJugador}`}
                  style={{ width: '50px', height: '50px', borderRadius: '50%' }}
                />
              </td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                {jugador.nombreJugador} {jugador.apellidoJugador}
              </td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                {jugador.nombreEquipo || 'Sin equipo'}
              </td>
              <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>
                {jugador.tarjetasAmarillas}
              </td>
              <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>
                {jugador.tarjetasAzules}
              </td>
              <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>
                {jugador.tarjetasRojas}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Paginación con iconos */}
      <div style={{ marginTop: '20px', textAlign: 'center' }}>
        <button
          onClick={() => cambiarPagina(paginaActual - 1)}
          disabled={paginaActual === 1}
          style={{
            marginRight: '10px',
            backgroundColor: 'transparent',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          <FaChevronLeft size={24} color="black" />
        </button>
        <span>
          Página {paginaActual} de {totalPaginas}
        </span>
        <button
          onClick={() => cambiarPagina(paginaActual + 1)}
          disabled={paginaActual === totalPaginas}
          style={{
            marginLeft: '10px',
            backgroundColor: 'transparent',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          <FaChevronRight size={24} color="black" />
        </button>
      </div>
    </div>
  );
};

export default AmonestacionesComponent;
